module.exports = __webpack_public_path__ + "img/public/SiteIcons/filterCalIcon.svg?6bbdf75e";